"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: payroll/deposit-switch-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fpayroll%2Fdeposit-switch-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositSwitchServiceClient = exports.HasDirectDepositResponse = exports.HasDirectDepositRequest = exports.TruvLinkingToken = exports.TruvTokenRequest = exports.GetDepositSwitchResponse = exports.GetDepositSwitchRequest = exports.ListDepositSwitchResponse = exports.ListDepositSwitchRequest = exports.SubmitLinkingTokenResponse = exports.SubmitLinkingTokenRequest = exports.GetDepositSwitchStateResponse = exports.GetDepositSwitchStateRequest = exports.GetProviderTokenResponse = exports.GetProviderTokenRequest = exports.DepositSwitchDetails = exports.DepositSwitchState = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const deposit_switch_1 = require("./deposit-switch");
const protobufPackage = 'com.step.payroll.deposit.proto';
function createBaseDepositSwitchState() {
    return { hasPendingDepositSwitch: false };
}
exports.DepositSwitchState = {
    fromJSON(object) {
        const message = {
            hasPendingDepositSwitch: isSet(object.hasPendingDepositSwitch)
                ? globalThis.Boolean(object.hasPendingDepositSwitch)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hasPendingDepositSwitch !== false) {
            obj.hasPendingDepositSwitch = message.hasPendingDepositSwitch;
        }
        return obj;
    },
    create(base) {
        return exports.DepositSwitchState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositSwitchState();
        message.hasPendingDepositSwitch = object.hasPendingDepositSwitch ?? false;
        return message;
    },
};
function createBaseDepositSwitchDetails() {
    return {
        id: '',
        status: deposit_switch_1.DepositSwitchStatus.INVALID_DEPOSIT_SWITCH_STATUS,
        depositAmount: undefined,
        employer: '',
    };
}
exports.DepositSwitchDetails = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            status: isSet(object.status)
                ? (0, deposit_switch_1.depositSwitchStatusFromJSON)(object.status)
                : deposit_switch_1.DepositSwitchStatus.INVALID_DEPOSIT_SWITCH_STATUS,
        };
        if (isSet(object.depositAmount)) {
            message.depositAmount = deposit_switch_1.DepositAmount.fromJSON(object.depositAmount);
        }
        if (isSet(object.employer)) {
            message.employer = globalThis.String(object.employer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.status !== deposit_switch_1.DepositSwitchStatus.INVALID_DEPOSIT_SWITCH_STATUS) {
            obj.status = (0, deposit_switch_1.depositSwitchStatusToJSON)(message.status);
        }
        if (message.depositAmount !== undefined) {
            obj.depositAmount = deposit_switch_1.DepositAmount.toJSON(message.depositAmount);
        }
        if (message.employer !== undefined && message.employer !== '') {
            obj.employer = message.employer;
        }
        return obj;
    },
    create(base) {
        return exports.DepositSwitchDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositSwitchDetails();
        message.id = object.id ?? '';
        message.status = object.status ?? deposit_switch_1.DepositSwitchStatus.INVALID_DEPOSIT_SWITCH_STATUS;
        message.depositAmount = (object.depositAmount !== undefined && object.depositAmount !== null)
            ? deposit_switch_1.DepositAmount.fromPartial(object.depositAmount)
            : undefined;
        message.employer = object.employer ?? '';
        return message;
    },
};
function createBaseGetProviderTokenRequest() {
    return { truv: undefined, destinationAccountId: '' };
}
exports.GetProviderTokenRequest = {
    fromJSON(object) {
        const message = {
            destinationAccountId: isSet(object.destinationAccountId)
                ? globalThis.String(object.destinationAccountId)
                : '',
        };
        if (isSet(object.truv)) {
            message.truv = exports.TruvTokenRequest.fromJSON(object.truv);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.truv !== undefined) {
            obj.truv = exports.TruvTokenRequest.toJSON(message.truv);
        }
        if (message.destinationAccountId !== '') {
            obj.destinationAccountId = message.destinationAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetProviderTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProviderTokenRequest();
        message.truv = (object.truv !== undefined && object.truv !== null)
            ? exports.TruvTokenRequest.fromPartial(object.truv)
            : undefined;
        message.destinationAccountId = object.destinationAccountId ?? '';
        return message;
    },
};
function createBaseGetProviderTokenResponse() {
    return { token: '' };
}
exports.GetProviderTokenResponse = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? globalThis.String(object.token) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== '') {
            obj.token = message.token;
        }
        return obj;
    },
    create(base) {
        return exports.GetProviderTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProviderTokenResponse();
        message.token = object.token ?? '';
        return message;
    },
};
function createBaseGetDepositSwitchStateRequest() {
    return { provider: deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER };
}
exports.GetDepositSwitchStateRequest = {
    fromJSON(object) {
        const message = {
            provider: isSet(object.provider)
                ? (0, deposit_switch_1.depositSwitchProviderFromJSON)(object.provider)
                : deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.provider !== deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER) {
            obj.provider = (0, deposit_switch_1.depositSwitchProviderToJSON)(message.provider);
        }
        return obj;
    },
    create(base) {
        return exports.GetDepositSwitchStateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDepositSwitchStateRequest();
        message.provider = object.provider ?? deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER;
        return message;
    },
};
function createBaseGetDepositSwitchStateResponse() {
    return { state: exports.DepositSwitchState.fromPartial({}) };
}
exports.GetDepositSwitchStateResponse = {
    fromJSON(object) {
        const message = {
            state: isSet(object.state)
                ? exports.DepositSwitchState.fromJSON(object.state)
                : exports.DepositSwitchState.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.state !== undefined) {
            obj.state = exports.DepositSwitchState.toJSON(message.state);
        }
        return obj;
    },
    create(base) {
        return exports.GetDepositSwitchStateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDepositSwitchStateResponse();
        message.state = (object.state !== undefined && object.state !== null)
            ? exports.DepositSwitchState.fromPartial(object.state)
            : exports.DepositSwitchState.fromPartial({});
        return message;
    },
};
function createBaseSubmitLinkingTokenRequest() {
    return { truv: undefined };
}
exports.SubmitLinkingTokenRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.truv)) {
            message.truv = exports.TruvLinkingToken.fromJSON(object.truv);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.truv !== undefined) {
            obj.truv = exports.TruvLinkingToken.toJSON(message.truv);
        }
        return obj;
    },
    create(base) {
        return exports.SubmitLinkingTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubmitLinkingTokenRequest();
        message.truv = (object.truv !== undefined && object.truv !== null)
            ? exports.TruvLinkingToken.fromPartial(object.truv)
            : undefined;
        return message;
    },
};
function createBaseSubmitLinkingTokenResponse() {
    return {};
}
exports.SubmitLinkingTokenResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SubmitLinkingTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubmitLinkingTokenResponse();
        return message;
    },
};
function createBaseListDepositSwitchRequest() {
    return { provider: deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER };
}
exports.ListDepositSwitchRequest = {
    fromJSON(object) {
        const message = {
            provider: isSet(object.provider)
                ? (0, deposit_switch_1.depositSwitchProviderFromJSON)(object.provider)
                : deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.provider !== deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER) {
            obj.provider = (0, deposit_switch_1.depositSwitchProviderToJSON)(message.provider);
        }
        return obj;
    },
    create(base) {
        return exports.ListDepositSwitchRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListDepositSwitchRequest();
        message.provider = object.provider ?? deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER;
        return message;
    },
};
function createBaseListDepositSwitchResponse() {
    return { depositSwitches: [] };
}
exports.ListDepositSwitchResponse = {
    fromJSON(object) {
        const message = {
            depositSwitches: globalThis.Array.isArray(object?.depositSwitches)
                ? object.depositSwitches.map((e) => exports.DepositSwitchDetails.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.depositSwitches?.length) {
            obj.depositSwitches = message.depositSwitches.map((e) => exports.DepositSwitchDetails.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListDepositSwitchResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListDepositSwitchResponse();
        message.depositSwitches =
            object.depositSwitches?.map((e) => exports.DepositSwitchDetails.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetDepositSwitchRequest() {
    return { depositId: '', provider: deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER };
}
exports.GetDepositSwitchRequest = {
    fromJSON(object) {
        const message = {
            depositId: isSet(object.depositId) ? globalThis.String(object.depositId) : '',
            provider: isSet(object.provider)
                ? (0, deposit_switch_1.depositSwitchProviderFromJSON)(object.provider)
                : deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.depositId !== '') {
            obj.depositId = message.depositId;
        }
        if (message.provider !== deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER) {
            obj.provider = (0, deposit_switch_1.depositSwitchProviderToJSON)(message.provider);
        }
        return obj;
    },
    create(base) {
        return exports.GetDepositSwitchRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDepositSwitchRequest();
        message.depositId = object.depositId ?? '';
        message.provider = object.provider ?? deposit_switch_1.DepositSwitchProvider.INVALID_PROVIDER;
        return message;
    },
};
function createBaseGetDepositSwitchResponse() {
    return { depositSwitch: exports.DepositSwitchDetails.fromPartial({}) };
}
exports.GetDepositSwitchResponse = {
    fromJSON(object) {
        const message = {
            depositSwitch: isSet(object.depositSwitch)
                ? exports.DepositSwitchDetails.fromJSON(object.depositSwitch)
                : exports.DepositSwitchDetails.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.depositSwitch !== undefined) {
            obj.depositSwitch = exports.DepositSwitchDetails.toJSON(message.depositSwitch);
        }
        return obj;
    },
    create(base) {
        return exports.GetDepositSwitchResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDepositSwitchResponse();
        message.depositSwitch = (object.depositSwitch !== undefined && object.depositSwitch !== null)
            ? exports.DepositSwitchDetails.fromPartial(object.depositSwitch)
            : exports.DepositSwitchDetails.fromPartial({});
        return message;
    },
};
function createBaseTruvTokenRequest() {
    return {};
}
exports.TruvTokenRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.TruvTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTruvTokenRequest();
        return message;
    },
};
function createBaseTruvLinkingToken() {
    return { publicToken: '', employer: '' };
}
exports.TruvLinkingToken = {
    fromJSON(object) {
        const message = {
            publicToken: isSet(object.publicToken) ? globalThis.String(object.publicToken) : '',
        };
        if (isSet(object.employer)) {
            message.employer = globalThis.String(object.employer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.publicToken !== '') {
            obj.publicToken = message.publicToken;
        }
        if (message.employer !== undefined && message.employer !== '') {
            obj.employer = message.employer;
        }
        return obj;
    },
    create(base) {
        return exports.TruvLinkingToken.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTruvLinkingToken();
        message.publicToken = object.publicToken ?? '';
        message.employer = object.employer ?? '';
        return message;
    },
};
function createBaseHasDirectDepositRequest() {
    return {};
}
exports.HasDirectDepositRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.HasDirectDepositRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseHasDirectDepositRequest();
        return message;
    },
};
function createBaseHasDirectDepositResponse() {
    return { hasDirectDeposit: false };
}
exports.HasDirectDepositResponse = {
    fromJSON(object) {
        const message = {
            hasDirectDeposit: isSet(object.hasDirectDeposit)
                ? globalThis.Boolean(object.hasDirectDeposit)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hasDirectDeposit !== false) {
            obj.hasDirectDeposit = message.hasDirectDeposit;
        }
        return obj;
    },
    create(base) {
        return exports.HasDirectDepositResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHasDirectDepositResponse();
        message.hasDirectDeposit = object.hasDirectDeposit ?? false;
        return message;
    },
};
/**
 * Deposit Switch Service to handle direct deposit switch.
 */
class DepositSwitchServiceClient {
    rpc;
    name = 'com.step.payroll.deposit.proto.DepositSwitchService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/payroll';
    methods = [{
            name: 'GetProviderToken',
            requestType: exports.GetProviderTokenRequest,
            responseType: exports.GetProviderTokenResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SubmitLinkingToken',
            requestType: exports.SubmitLinkingTokenRequest,
            responseType: exports.SubmitLinkingTokenResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ListDepositSwitch',
            requestType: exports.ListDepositSwitchRequest,
            responseType: exports.ListDepositSwitchResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetDepositSwitch',
            requestType: exports.GetDepositSwitchRequest,
            responseType: exports.GetDepositSwitchResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetDepositSwitchState',
            requestType: exports.GetDepositSwitchStateRequest,
            responseType: exports.GetDepositSwitchStateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'HasDirectDeposit',
            requestType: exports.HasDirectDepositRequest,
            responseType: exports.HasDirectDepositResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Retrieves a token needed for mobile client to initiate direct deposit
     * switch using a third party service.
     */
    getProviderToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Submits a "linking" token. The mobile client should be able to submit this
     * token once the user has linked their payroll provider and input direct
     * deposit switch details using the third party service.
     */
    submitLinkingToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Lists the deposit switches made by user.
     */
    listDepositSwitch(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets a deposit switch by id for a user.
     */
    getDepositSwitch(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets deposit switch state for a user.
     */
    getDepositSwitchState(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get direct deposit status for a user.
     */
    hasDirectDeposit(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.DepositSwitchServiceClient = DepositSwitchServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=deposit-switch-service.js.map